export function minWidth(width) {
  return window.innerWidth >= width;
}
export function maxWidth(width) {
  return window.innerWidth <= width;
}
